const mutations = {
    COMMIT_VOUCHER: (state, payload) => {
        state.voucher = payload
    },
}

export default mutations
